import { Injectable } from '@angular/core';
declare let THREE: any;
import { RendererService } from './renderer.service';

@Injectable()
export class TextureUtilsService {

  constructor(private rendererSrvc: RendererService) { }

  createOrUpdateMaterialMap(mesh?, img?) {
    if (mesh) {
      if (mesh.material.map)
        mesh.material.map.image = img;
      else {
        mesh.material.map = new THREE.Texture(img);
        mesh.material.map.anisotropy = this.rendererSrvc.getMaxAnisotropy();
      }
      mesh.material.map.needsUpdate = true;
      mesh.material.needsUpdate = true;
    }
    else {
      var a = this.rendererSrvc.getMaxAnisotropy();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/texture-utils.service.ts